import React from 'react';
import PropTypes from 'prop-types';
import { UX2 } from '@wsb/guac-widget-core';

export const styles = {
  thumbArrow: {
    width: '25px',
    color: 'section',
    cursor: 'pointer',
    zIndex: '2'
  }
};

function CarouselArrow(props) {
  const {
    Element: { Block, Icon }
  } = UX2;
  const { icon, numSlides, currentAssetIndex, onClick } = props;
  const step = icon === 'chevronRight' ? 1 : -1;
  const showLeftIcon = icon === 'chevronLeft' && currentAssetIndex > 0;
  const showRightIcon = icon === 'chevronRight' && currentAssetIndex < numSlides - 1;

  return (
    <Block id={ icon } style={ styles.thumbArrow }>
      { (showLeftIcon || showRightIcon) && (
        <Icon onClick={ () => onClick(currentAssetIndex + step) } icon={ icon } size='small' />
      ) }
    </Block>
  );
}

CarouselArrow.propTypes = {
  icon: PropTypes.string,
  prevSlide: PropTypes.func,
  nextSlide: PropTypes.func,
  numSlides: PropTypes.number,
  currentAssetIndex: PropTypes.number,
  onClick: PropTypes.func
};

export default CarouselArrow;
